<template>
  <q-input
    v-bind="attrs"
    ref="componentRef"
    class="o-input rounded-md"
    :class="'size-' + attrs.size + ' ' + attrs.edit"
    :size="null"
  >
    <template v-for="slot in Object.keys(slots)" #[slot]>
      <slot :name="slot" />
    </template>
  </q-input>
</template>

<script>
export default { inheritAttrs: false }
</script>

<script setup>
import { ref, useAttrs, useSlots } from 'vue'
const componentRef = ref(null)

const slots = useSlots()
const attrs = useAttrs()
const appendSize = attrs['append-size']
const appendsize = attrs['append-size'] ? attrs['append-size'] : '35px'
const prependsize = attrs['prepend-size'] ? attrs['prepend-size'] : '20px'

defineExpose({ componentRef })
</script>

<style lang="sass">
.o-input
  --prepend-size: v-bind(prependsize)
  --append-size: v-bind(appendsize)
  .q-field__append
      width: v-bind(appendSize) !important

  .q-field__prepend
    width: v-bind(prependsize) !important
</style>
